export const hsaPhoneNumber = "904-567-6033";
export const hsaSupportEmail = "customercare@homesafeconnect.com";
